// extracted by mini-css-extract-plugin
module.exports = {"icon":"MembershipWalletButton_icon__3A2l7","button":"MembershipWalletButton_button__2oV4I"};